/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypematchconnect3Inputs */

const zh_learn_mistakestypematchconnect3 = /** @type {(inputs: Learn_Mistakestypematchconnect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配对连线`)
};

const en_learn_mistakestypematchconnect3 = /** @type {(inputs: Learn_Mistakestypematchconnect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match Connect`)
};

const es_learn_mistakestypematchconnect3 = /** @type {(inputs: Learn_Mistakestypematchconnect3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar parejas`)
};

/**
* | output |
* | --- |
* | "Match Connect" |
*
* @param {Learn_Mistakestypematchconnect3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypematchconnect3 = /** @type {((inputs?: Learn_Mistakestypematchconnect3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypematchconnect3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypematchconnect3(inputs)
	if (locale === "en") return en_learn_mistakestypematchconnect3(inputs)
	return es_learn_mistakestypematchconnect3(inputs)
});
export { learn_mistakestypematchconnect3 as "learn_mistakesTypeMatchConnect" }